import { gql, useQuery } from '@apollo/client';
import {
  GetSegmentQuery,
  GetSegmentQueryVariables,
} from '../../../__generated__/queries-web';

export const GET_SEGMENT = gql`
  query GetSegment($where: SegmentUniqueFilterInput!) {
    segment(where: $where) {
      active
      id
      title
      ios
      android
      brandKey
      status
      editorialAlert
    }
  }
`;

export const useGetSegment = (id: string, skip?: boolean) =>
  useQuery<GetSegmentQuery, GetSegmentQueryVariables>(GET_SEGMENT, {
    variables: { where: { id } },
    skip: !id || skip,
  });
